const broadcastCategories = {
    INFO: 'info',
    WARN: 'warning',
    ERROR: 'error',
    RELEASE_NOTES: 'releaseNotes'
};
Object.freeze(broadcastCategories);
export default broadcastCategories;